import React, { createContext, useContext, useReducer } from "react";
import { initialState, emendasParlamentaresReducer, EmendasParlamentaresState } from "./emendas-parlamentares-reducer";

type EmendasParlamentaresContextType = {
    state: EmendasParlamentaresState;
    dispatch: React.Dispatch<any>;
};

const EmendasParlamentaresContext = createContext<EmendasParlamentaresContextType | undefined>(undefined);

export const EmendasParlamentaresProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(emendasParlamentaresReducer, initialState);

    return (
        <EmendasParlamentaresContext.Provider value={{ state, dispatch }}>
            {children}
        </EmendasParlamentaresContext.Provider>
    );
};

export const useEmendasParlamentaresState = () => {
    const context = useContext(EmendasParlamentaresContext);
    if (!context) {
        throw new Error("useEmendasParlamentaresState must be used within EmendasParlamentaresProvider");
    }
    return context.state;
};

export const useEmendasParlamentaresDispatch = () => {
    const context = useContext(EmendasParlamentaresContext);
    if (!context) {
        throw new Error("useEmendasParlamentaresDispatch must be used within EmendasParlamentaresProvider");
    }
    return context.dispatch;
};
